<style lang="scss">
    @import '~@/abstracts/_variables.scss';

    div#service-type-modal {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: rgba(0, 0, 0, .6);
        z-index: 99999;

        div.service-type-box {
            position: absolute;
            width: 100%;
            max-width: 530px;
            min-width: 320px;
            padding: 20px;
            background-color: #fff;
            border: 1px solid #ddd;
            box-shadow: 0 0 #000000, 0 0 #000000, 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1);
            -webkit-border-radius: 0.5rem;
            border-radius: 0.5rem;
            font-size: 16px;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);

            div.service-type-label {
                color: black;
                font-size: 18px;
                font-family: 'Raleway', sans-serif;
                font-weight: bold;
                text-align: center;
                margin-top: 5px;
                margin-bottom: 20px;
            }

            div.service-type-content {
                margin-bottom: 10px;
            }

            button.service-type-button {
                font-family: 'Raleway', sans-serif;
                font-weight: bold;
                display: block;
                margin: auto;
                outline: none;
                cursor: pointer;
                color: $secondary-color;
                width: 100%;
                font-size: 1rem;
                line-height: 1.5rem;
                background-color: rgba(229, 231, 235, 1);
                border-radius: 0.5rem;
                padding: 0.75rem;

                img {
                    width: 22px;
                }

                span {
                    vertical-align: middle;
                }

                &:hover {
                    background-color: rgba(209, 213, 219, 1);
                }
            }

            .centered {
                margin: auto;
            }
        }
    }

    /* Small only */
    @media screen and (max-width: 39.9375em) {
        div#service-type-modal {
            div.service-type-box {
                width: 95%;
            }
        }
    }

    /* Medium only */
    @media screen and (min-width: 40em) and (max-width: 63.9375em) {

    }

    /* Large only */
    @media screen and (min-width: 64em) and (max-width: 74.9375em) {

    }
</style>

<template>
    <div id="service-type-modal" v-show="show" v-on:click="show = false">
        <div class="service-type-box" v-on:click.stop="">
            <div class="service-type-label">{{ $t('servicetype.label') }}</div>

            <div class="grid-container">
                <div class="grid-x grid-padding-x">
                    <div class="large-12 medium-12 small-12 cell centered">
                        <div class="grid-x grid-padding-x">
                            <div v-for="workroomType in workroomTypes" v-if="(workroomType.ID == 20 && maintenanceIncluded == true) || workroomType.ID == 60" class="large-12 medium-12 small-12 cell service-type-content">
                                <button v-if="workroomType.WorkType == 'Údržba'" type="submit" @click.prevent="submitType(workroomType.ID)" class="service-type-button">
                                    <!--<img src="/img/icons/maintenance.png" v-bind:alt="$t('servicetype.maintenance')">-->
                                    <span>{{ $t('servicetype.maintenance') }}</span>
                                </button>

                                <button v-if="workroomType.WorkType == 'Pneumatiky'" type="submit" @click.prevent="submitType(workroomType.ID)" class="service-type-button">
                                    <!--<img src="/img/icons/tires.png" v-bind:alt="$t('servicetype.tires')">-->
                                    <span>{{ $t('servicetype.tires') }}</span>
                                </button>
                            </div>
                            <div v-if="maintenanceIncluded == true" class="large-12 medium-12 small-12 cell service-type-content">
                                <button type="submit" @click.prevent="submitCallingAction(20)" class="service-type-button">
                                    <!--<img src="/img/icons/calling-action.png" v-bind:alt="$t('servicetype.callingAction')">-->
                                    <span>{{ $t('servicetype.callingAction') }}</span>
                                </button>
                            </div>
                            <div class="large-12 medium-12 small-12 cell service-type-content">
                                <button type="submit" @click.prevent="submitChargingStations()" class="service-type-button">
                                    <!--<img src="/img/icons/charging-station.png" v-bind:alt="$t('servicetype.chargingStation')">-->
                                    <span>{{ $t('servicetype.chargingStation') }}</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {EventBus} from '../../event-bus.js';
    import _ from 'lodash';
    import Geocode from "../../api/geocode";

    export default {
        data() {
            return {
                show: false,
                workroomTypes: [],
                maintenanceIncluded: false
            }
        },

        mounted() {
            EventBus.$on('prompt-type', function (response) {
                this.show = true;
                this.response = response;
                this.maintenanceIncluded = response.data.maintenance_included;
                this.workroomTypes = _.orderBy(response.data.workroom_types, 'ID');

                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(position => {
                        this.setClientLocationOnType(position);
                    }, err => {
                        console.log('User denied Geolocation');
                    }, {
                        enableHighAccuracy: true,
                        timeout: 60000
                    });
                }
            }.bind(this));
        },

        methods: {
            setClientLocationOnType(position) {
                Geocode.getCountryCodeFromPosition(position)
                    .then((response) => {
                        if (response != 'CZ') {
                            this.$store.commit('setClientCurrentLocation', { location: { latitude: 50.08804, longitude: 14.42076 } })
                        } else {
                            this.$store.commit('setClientCurrentLocation', { location: { latitude: position.coords.latitude, longitude: position.coords.longitude } })
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                    });
            },

            submitType(type_id) {
                this.show = false;

                //this.$store.dispatch('flashMessageShow', { type: 'success', message: this.$t('auth.successMessageLogin') }, { root: true })

                localStorage.removeItem('make_id');
                this.$store.commit('setMakeId', null);
                this.$store.commit('setDistanceFilter', 10);

                return this.$store.dispatch('setJwt', this.response.data.jwt).then(() => {
                    return this.$store.dispatch('setWorkroom', type_id).then(() => {
                        return this.$store.dispatch('setMaintenanceIncluded', this.response.data.maintenance_included).then(() => {
                            return this.$store.dispatch('setReplCarEntitlementCode', this.response.data.repl_car_entitlement_code).then(() => {
                                return this.$store.dispatch('setLicensePlate', this.response.data.license_plate).then(() => {}, () => {}).finally(() => {
                                    if (this.$router.currentRoute.name == 'services' || this.$router.currentRoute.name == 'service') {
                                        window.location.reload();
                                    } else {
                                        return this.$router.push(this.$route.params.onLogin || '/');
                                    }
                                });
                            }, () => {});
                        }, () => {});
                    }, () => {});
                }, () => {});
            },

            submitCallingAction(type_id) {
                this.show = false;

                this.$store.commit('setDistanceFilter', 10);

                return this.$store.dispatch('setJwt', this.response.data.jwt).then(() => {
                    return this.$store.dispatch('setWorkroom', type_id).then(() => {
                        return this.$store.dispatch('setMaintenanceIncluded', this.response.data.maintenance_included).then(() => {
                            return this.$store.dispatch('setReplCarEntitlementCode', this.response.data.repl_car_entitlement_code).then(() => {
                                return this.$store.dispatch('setMakeId', this.response.data.make_id).then(() => {
                                    return this.$store.dispatch('setLicensePlate', this.response.data.license_plate).then(() => {}, () => {}).finally(() => {
                                        if (this.$router.currentRoute.name == 'services' || this.$router.currentRoute.name == 'service') {
                                            window.location.reload();
                                        } else {
                                            return this.$router.push(this.$route.params.onLogin || '/');
                                        }
                                    });
                                }, () => {});
                            }, () => {});
                        }, () => {});
                    }, () => {});
                }, () => {});
            },

            submitChargingStations() {
                this.show = false;

                return this.$store.dispatch('setJwt', this.response.data.jwt).then(() => {
                    return this.$store.dispatch('setMaintenanceIncluded', this.response.data.maintenance_included).then(() => {
                        return this.$store.dispatch('setReplCarEntitlementCode', this.response.data.repl_car_entitlement_code).then(() => {
                            return this.$store.dispatch('setMakeId', this.response.data.make_id).then(() => {
                                return this.$store.dispatch('setLicensePlate', this.response.data.license_plate).then(() => {}, () => {}).finally(() => {
                                    if (this.$router.currentRoute.name == 'charging-stations' || this.$router.currentRoute.name == 'charging-station') {
                                        window.location.reload();
                                    } else {
                                        return this.$router.push({ name: 'charging-stations' });
                                    }
                                });
                            }, () => {});
                        }, () => {});
                    }, () => {});
                }, () => {});
            },
        }
    }
</script>
